<template>
    <div class="d-inline">
        <b-button variant="outline-secondary" @click="openModal">
            <template v-if="(hasEmoji)">
                <h1 class="display-4">{{ selectedEmoji }}</h1>
            </template>
            <template v-else>
                <span class="font-weight-bolder">
                    Pick an emoji
                </span>
            </template>
        </b-button>
        <b-button variant="hover-transparent-danger" class="btn-icon ml-5" @click="removeEmoji">
            <i class="fas fa-times"></i>
        </b-button>
        <b-modal
            size="lg"
            ref="select-emoji-modal"
            centered
            title="Pick an Emoji for your Hashtag Set"
        >
            <template v-if="(hasEmoji)">
                <div class="card card-custom card-body gutter-b">
                    <h3>Selected Emoji:</h3>
                    <h1 class="display-2">{{ selectedEmoji }}</h1>
                </div>
            </template>

            <template v-for="(emojiset, title) in emojis">
                <h3>{{ title }}</h3>
                <div class="row gutter-b">
                    <template v-for="(emoji, textual) in emojiset">
                        <b-button
                            class="btn-icon col-1 text-center font-size-h1"
                            variant="white"
                            @click="setEmoji(emoji)"
                        >
                            {{ emoji }}
                        </b-button>
                    </template>
                </div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <b-button type="submit" variant="success" @click="emitSavedEmoji">
                    Select emoji
                </b-button>
                <!-- Button with custom close trigger value -->
                <b-button variant="outline-secondary" @click="hide()">
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import ALL_EMOJIS from "@/view/content/Custom/emojis";
export default {
    name: "emojiPicker",
    components: {},
    props: {
        propCurrentEmoji: String,
    },
    mounted() {
        this.handleMount();
    },
    methods: {
        handleMount() {
            if (typeof this.propCurrentEmoji !== "undefined") {
                this.selectedEmoji = this.propCurrentEmoji;
            }
        },
        removeEmoji() {
            this.setEmoji(null);
        },
        setEmoji(emoji) {
            this.selectedEmoji = emoji;
            this.emitSavedEmoji();
            this.closeModal();
        },
        closeModal() {
            this.$refs["select-emoji-modal"].hide();
        },
        openModal() {
            this.$refs["select-emoji-modal"].show();
        },
        emitSavedEmoji() {
            this.$emit("emitSavedEmoji", this.selectedEmoji);
        },
    },
    computed: {
        hasEmoji() {
            if (
                this.selectedEmoji === undefined ||
                this.selectedEmoji === null ||
                this.selectedEmoji === ""
            ) {
                return false;
            }
            return true;
        },
    },
    data() {
        return {
            // Errors
            errors: [],

            // Data
            selectedEmoji: null,

            // Raw Emojis
            emojis: ALL_EMOJIS,
        };
    },
};
</script>
